import { useContext } from 'react';
import { UploadUIContext } from './UploadSelector';

/**
 * Hook for accessing Upload UI state
 *
 * Provides access to:
 * - UI state (show/hide, minimize, steps)
 * - Form state (service provider, modality)
 * - Upload flow state (batch ID, results, loading)
 * - Actions (show, hide, reset)
 *
 * Note: Processing data is now handled by useUploadData hook
 */
export function useUploadUI() {
  const context = useContext(UploadUIContext);

  if (!context) {
    throw new Error(`Upload UI components cannot be rendered outside the UploadSelector component`);
  }
  return context;
}
